import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { ServicesReportPayload } from 'app/types/reports/service'

export const createServiceReport = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.service.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ServicesReportPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
